<template>
  <div class="elc-custom-referral-info">
    <div class="tip-message">{{ $t('personal.referrals.rewards.custom.elc.tipMessage') }}</div>
  </div>
</template>

<script>

export default {
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.elc-custom-referral-info {
  display: flex;
  margin: 15px;
  padding: 10px 15px;
  border-radius: 5px;
  background-color: #e7ebec;
  justify-content: center;

  .tip-message {
    margin: auto;
    text-align: center;
  }
}
.page-moblie {
  .elc-custom-referral-info {
    height: 80px;
    background: #fff;
  }
}
</style>
